<script>
export default {
  props: {
    documentId: {
      type: Number,
      default: null
    },
    pageCount: {
      type: Number,
      default: 0
    },
    maxHeight: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      imageKey: 0,
      pageNumber: 1,
      maxPageBreakpoint: 9,
      previewImages: new Array(this.pageCount),
      noImage: '' // empty string to prevent img-src errors
    }
  },
  computed: {
    height() {
      return this.$vuetify.breakpoint.height > 925 ? this.maxHeight : '70vh'
    },
    heightCarousel() {
      return this.$vuetify.breakpoint.height > 925
        ? this.maxHeight + (this.pageCount > 1 ? 50 : 0)
        : 'calc(70vh + ' + (this.pageCount > 1 ? '50px' : '0px') + ')'
    }
  },
  methods: {
    async loadNextImage(pageNumber, override = false) {
      if (pageNumber == undefined) return
      this.pageNumber = pageNumber + 1
      if (this.previewImages[pageNumber] === undefined || override) {
        await this.$uploadService
          .getDocumentImage(this.documentId, pageNumber)
          .then(res => {
            this.previewImages[pageNumber] = res.image
          })
          .catch(() => {
            this.previewImages[pageNumber] = this.noImage
          })
        this.imageKey++
      }
    }
  }
}
</script>
<template>
  <div class="grey lighten-4 mx-auto">
    <v-carousel
      :height="heightCarousel"
      :style="'border:1px solid rgba(0, 0, 0, 0.12);'"
      :show-arrows="previewImages.length > 1"
      :hide-delimiters="
        previewImages.length <= 1 || previewImages.length > maxPageBreakpoint"
      @change="loadNextImage($event)">
      <v-carousel-item
        v-for="(image, index) in previewImages"
        :key="index"
        style="position: relative">
        <v-img :key="imageKey" contain :height="height" :src="image" />
        <template #placeholder>
          <v-layout fill-height align-center justify-center ma-0>
            <v-alert
              v-if="image === noImage"
              type="error"
              class="ma-12"
              dense
              text>
              {{ $t('component.documentValidation.validationResultImage.image.load.failed') }}
            </v-alert>
            <v-progress-circular
              v-else
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-layout>
        </template>
        <v-row
          v-if="previewImages.length > maxPageBreakpoint"
          class="text-center v-carousel__controls ml-0">
          <v-col>
            <span class="white--text">
              {{ pageNumber }} / {{ previewImages.length }}
            </span>
          </v-col>
        </v-row>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>
<style lang="scss" scoped>
img {
  height: 100%;
}
</style>
